export const LOAD_ISSUE_LIST = 'LOAD_ISSUE_LIST';
export const SET_ISSUE_LIST_LOADING_STATUS = 'SET_ISSUE_LIST_LOADING_STATUS';
export const LOAD_SINGLE_ISSUE = 'LOAD_SINGLE_ISSUE';
export const SET_SINGLE_ISSUE_LOADING_STATUS = 'SET_SINGLE_ISSUE_LOADING_STATUS';
export const SET_SINGLE_ISSUE_UPDATING_STATUS = 'SET_SINGLE_ISSUE_UPDATING_STATUS';
export const SET_NAV_SECTION_VISIBLE = 'SET_NAV_SECTION_VISIBLE';
export const SET_SECTION_EDIT_STATUS = 'SET_SECTION_EDIT_STATUS';
export const LOAD_PREVIOUS_VERSION = 'LOAD_PREVIOUS_VERSION';
